import React from 'react'

import Icon from '../icons/Icon'
import {AnimatedProps} from './AnimatedInterface'

const AnimatedSuccess = ({onAnimationEnd, onAnimationStart}: AnimatedProps) => {
  return (
    <div
      className="flex items-center justify-center w-full h-full transform rounded-full bg-kwota-primary animate-scale-in"
      onAnimationStart={() => onAnimationStart?.()}
    >
      <div
        className="w-1/3 h-1/3 transform opacity-0 animate-spin-in [animation-delay:600ms]"
        onAnimationEnd={() => onAnimationEnd?.()}
      >
        <Icon icon="tick" size="full" className="fill-white pointer-events-none" />
      </div>
    </div>
  )
}

export default AnimatedSuccess
